import { render, staticRenderFns } from "./ContentPageWithoutHero.vue?vue&type=template&id=61cb7dcd&"
import script from "./ContentPageWithoutHero.vue?vue&type=script&lang=js&"
export * from "./ContentPageWithoutHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ComponentLoader: require('/vercel/path0/components/general/ComponentLoader.vue').default})
